import { fromJS } from 'immutable';

import * as globalActions from '../actions/global';

const initialState = {
  configuration: {},
  userData: {}, // not immutable
  userDataIm: {}, // not immutable
  subscriptionExpired: false,
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case globalActions.CONFIGURE: {
      return state.setIn(['configuration'], fromJS(action.payload));
    }
    case globalActions.SET_USER_DATA: {
      return state
        .setIn(['userData'], action.payload)
        .setIn(['userDataIm'], fromJS({ ...action.payload }));
    }
    case globalActions.SET_SUBSCRIPTION_EXPIRED: {
      return state.setIn(['subscriptionExpired'], action.payload);
    }
    case globalActions.SET_DEPLOY_GIT_SHA: {
      return state.setIn(
        ['configuration', 'keys', 'generalConfig', 'deployGitSHA'],
        fromJS(action.payload),
      );
    }

    default: {
      return state;
    }
  }
};
